var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 1.90418H15.8333V9.42312H3.16667V1.90418ZM15.8333 10.9269C16.2533 10.9269 16.656 10.7685 16.9529 10.4865C17.2499 10.2044 17.4167 9.82195 17.4167 9.42312V1.90418C17.4167 1.06958 16.7042 0.400391 15.8333 0.400391H3.16667C2.28792 0.400391 1.58333 1.06958 1.58333 1.90418V9.42312C1.58333 9.82195 1.75015 10.2044 2.04708 10.4865C2.34401 10.7685 2.74674 10.9269 3.16667 10.9269H0V12.4307H19V10.9269H15.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.fb91420d.svg";
export { ForwardRef as ReactComponent };